import type { ReactNode } from 'react'
import { IconoVacio } from './iconos'

interface Props {
  titulo: string
  descripcion?: string
  /** Accion opcional: normalmente "limpiar filtros". */
  accion?: ReactNode
}

/**
 * Hueco honesto cuando no hay nada que mostrar. Icono del modulo de dominio,
 * nunca un emoji: se ven distintos en cada sistema y no siguen el tema.
 */
export function EstadoVacio({ titulo, descripcion, accion }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-borde-fuerte bg-superficie px-6 py-12 text-center">
      <IconoVacio aria-hidden="true" className="size-8 text-tinta-apagada" />
      <p className="text-sm font-medium text-tinta">{titulo}</p>
      {descripcion ? <p className="max-w-sm text-sm text-tinta-apagada">{descripcion}</p> : null}
      {accion}
    </div>
  )
}
